'use strict';

var util = require('../util/util');
var debounce = require('lodash/debounce');

require('ion-rangeslider');

/**
 * Updates ion range slider data attributes
 * @param {Object} data The object holding the from and to values
 */
function rangeStart(data) {
    var $range = $('body').find('.js-price-range-slider');
    var $inputFrom = 'data-selected-from';
    var $inputTo = 'data-selected-to';

    $range.attr($inputFrom, data.from);
    $range.attr($inputTo, data.to);
}

/**
 * Inits Ion Range Slider
 */
function initIonRangeSlider() {
    var $range = $('.js-price-range-slider');
    $range.ionRangeSlider({
        skin: 'round',
        type: 'double',
        min: parseInt($range.attr('data-init-from'), 10),
        max: parseInt($range.attr('data-init-to'), 10),
        from: $range.attr('data-selected-from'),
        to: $range.attr('data-selected-to'),
        onStart: rangeStart,
        onFinish: function (data) {
            rangeStart(data);
            $('.js-refine-bar').trigger('search:refine', $('.js-price-range-form'));
        }
    });
}
/* eslint-disable */
/**
 * Check sticky elements position
 */

function stickyElementsPosition(headerHeight, element) {
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    if (!isIE11) {
        return false;
    }

    $(element).css('top', '');

    $(window).on('scroll', debounce(function () {
        var newHeaderHeight = $('header').outerHeight(false);
        if (newHeaderHeight > headerHeight) {
            headerHeight = newHeaderHeight;
        }

        if ($(element).css('position') === 'fixed') {
            $(element).css('top', headerHeight);
        } else {
            $(element).css('top', '');
        }
    }));
}
/* eslint-enable */

/**
 * Initialize Mobile Filter Panel
 */
function initStickyFilterBar() {
    var headerHeight = $('header').outerHeight(false);
    // calculate top position of sticky element
    $('.filter-bar').css('top', headerHeight);

    stickyElementsPosition(headerHeight, '.filter-bar');
}

/**
 * Initializes Brand Search
 */
function brandSearch() {
    var brandSearchInput = $('.search-by-attribute');
    brandSearchInput.bind('input', function () {
        var brandSearchTerm = this.value.trim().toLowerCase();
        var $attributes = $(this).parents('.value').find('li');

        if (brandSearchTerm.length > 0) {
            $attributes.hide();
            $attributes.filter(function () {
                return $(this)
                    .attr('data-attribute-value').toLowerCase()
                    .indexOf(brandSearchTerm) >= 0;
            }).show();
        } else {
            $attributes.show();
        }
    });
}

/**
 * Initialize Refinements
 */
function initRefinements() {
    var headerHeight = $('header').outerHeight(true); // header height
    var filterBarHeight = $('.filter-bar').outerHeight(false);
    var refinement = $('.sticky-refinement');
    refinement.css('top', '');

    // calculate top position of sticky element
    if (util.mediaBreakpointUp('md')) {
        refinement.css('top', headerHeight + filterBarHeight);

        stickyElementsPosition(headerHeight + filterBarHeight, '.sticky-refinement');
    }
    // reinitializing searchByBrands
    brandSearch();
}

/**
 * Changes number of found products for customer
 */
function resetAmountOfProducts() {
    var $productsInfo = $('.js-product-amount');
    if ($productsInfo.length > 0) {
        $('.js-change-num').text($productsInfo.data('products'));
    } else {
        $('.js-change-num').text(0);
    }
}

var exports = {

    /**
     * Init ion-Range slider
     */

    initIonRangeSlider: initIonRangeSlider,

    reinitIonRangeSlider: function () {
        $('body').on('refinement:updated', function (event, params) {
            rangeStart(params);
            initIonRangeSlider();
        });
    },

    /**
     * Init sticky filter bar with initStickyPolyfill
     */
    initStickyFilterBar: function () {
        initStickyFilterBar();
        // reinitializing Sticky FilterBar onresize
        util.smartResize(function () {
            initStickyFilterBar();
        });
    },

    initRefinements: function () {
        initRefinements();
        // reinitializing Sticky refinements onresize
        util.smartResize(function () {
            initRefinements();
        });
    },

    stickyRefinement: function () {
        $('body').on('click', '.refinements-trigger', function () {
            var $grid = $('.grid-section');
            // show open/close filter button
            $(this).toggleClass('active');
            // updating grid wrapper size
            $grid.toggleClass('full-width-grid');
            $('.refinement-bar').toggleClass('active');
            // reinitializing searchByBrands
            brandSearch();
            $('body').trigger('refinements:toggled');
        });
    },
    updateRefinements: function () {
        // update refinements On Filter Update
        $('body').on(
            'refinement:updated',
            function () {
                // reinitializing searchByBrands
                brandSearch();
                resetAmountOfProducts();
            }).on('search:sort', '[name=sort-order]', function () {
                setTimeout(function () {
                    // reinitializing searchByBrands
                    brandSearch();
                }, 500);
            }).on('refinement:close', function () {
                setTimeout(function () {
                    // reinitializing searchByBrands
                    util.unlockBodyScroll();
                    brandSearch();
                }, 500);
            });
    },
    sortSelectIonSliderReinit: function () {
        $('body').on('search:sortUpdated', function () {
            initIonRangeSlider();
        });
    }
};

module.exports = exports;
